/*
 * ttg-namensfeld.js — verschiebbares und skalierbares Ebenen-BÜNDEL
 * (Schema v1.19, Foto-Fußmatte Design 2 „Banner").
 *
 * EIGENSTÄNDIGES Modul neben der Engine (CLAUDE.md §3). Die Engine liefert die
 * Rechenseite und die einzige Schreib-API:
 *     engine.setGroupAdjust(id, {xPercent, yPercent, scale})  → geklemmt zurück
 *     engine.getGroupAdjust(id) / engine.resetGroupAdjust(id)
 * Sie klemmt selbst (Skalierungsgrenzen + Mattenfläche) und zeichnet neu; dieses
 * Modul macht NUR die Bedienung und richtet seinen Rahmen nach dem Rückgabewert
 * aus — nie nach dem Wunschwert, sonst liefe der Griff aus der Klemmung heraus.
 *
 * Bedienung:
 *  · Ziehen im Rahmen  → verschieben (ein Zeiger).
 *  · Ziehen am Eckgriff → skalieren (Abstand zur Gruppenmitte als Maß).
 *  · Zwei Finger im Rahmen → skalieren (Pinch), ohne den Griff zu treffen.
 *  · Tastatur: Pfeiltasten verschieben, +/− skalieren (Rahmen ist fokussierbar).
 *
 * Der Rahmen ist reine BEDIEN-Oberfläche: Er lebt in der Bühne, aber der
 * Snapshot zeichnet aus den Layer-Werten auf ein Canvas — er kann also gar
 * nicht mitgedruckt werden.
 *
 * Ohne `layout.groups` tut das Modul nichts (und wird gar nicht erst geladen).
 */
(function () {
  'use strict';

  var SCHRITT = 0.5;        // Prozentpunkte je Pfeiltaste
  var SCHRITT_SCALE = 0.05; // je +/−

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function gruppenIds(engine) {
    var g = (engine.config.layout && engine.config.layout.groups) || {};
    var out = [];
    for (var k in g) if (Object.prototype.hasOwnProperty.call(g, k)) out.push(k);
    return out;
  }

  /** Bühne (quadratisch, aspect-ratio 1/1) als Bezug für alle Prozentrechnungen.
   *  Sie trägt kein eigenes ref — sie ist der Elternknoten der Ebenen. Über eine
   *  vorhandene Ebene nach oben zu gehen ist zuverlässiger als eine
   *  dokumentweite Suche: bei zwei Konfiguratoren auf einer Seite träfe die
   *  sonst die falsche Bühne. */
  function buehne(engine) {
    var refs = engine.refs || {};
    var kandidat = refs.base || refs.photo || refs.motif;
    if (!kandidat && refs.deco) {
      for (var k in refs.deco) { if (refs.deco[k]) { kandidat = refs.deco[k]; break; } }
    }
    if (!kandidat) return null;
    return kandidat.closest('[data-ttg-preview]') || kandidat.parentElement;
  }

  /** Rahmen auf die aktuelle Gruppen-Ausdehnung setzen (Bühnen-Prozent). */
  function richteAus(engine, gid, ui) {
    var st = engine.getGroupAdjust(gid);
    if (!st) return;
    var u = engine._groupUnionPct(gid, st);
    if (!u) return;
    ui.rahmen.style.left = u.x0 + '%';
    ui.rahmen.style.top = u.y0 + '%';
    ui.rahmen.style.width = (u.x1 - u.x0) + '%';
    ui.rahmen.style.height = (u.y1 - u.y0) + '%';
    ui.rahmen.setAttribute('aria-valuenow', Math.round(st.scale * 100));
  }

  function bindGruppe(engine, gid) {
    var stage = buehne(engine);
    if (!stage) return;
    var S = engine.config.strings || {};
    var def = (engine.config.layout.groups || {})[gid] || {};

    var rahmen = el('div', 'ttg__grp');
    rahmen.setAttribute('tabindex', '0');
    rahmen.setAttribute('role', 'application');
    rahmen.setAttribute('aria-label', def.label || S.group_label
      || 'Namensfeld – ziehen zum Verschieben, Ecke ziehen zum Vergrößern');
    var griff = el('span', 'ttg__grp-griff');
    griff.setAttribute('aria-hidden', 'true');
    rahmen.appendChild(griff);
    stage.appendChild(rahmen);

    var ui = { rahmen: rahmen, griff: griff };
    var zeiger = new Map();
    var start = null;

    function pctProPx() {
      var r = stage.getBoundingClientRect();
      return r.width ? 100 / r.width : 0;   // Bühne ist quadratisch
    }

    function beginn(e) {
      var st = engine.getGroupAdjust(gid);
      var u = engine._groupUnionPct(gid, st);
      start = {
        st: { xPercent: st.xPercent, yPercent: st.yPercent, scale: st.scale },
        sx: e.clientX, sy: e.clientY,
        modus: (e.target === griff) ? 'scale' : 'move',
        dist: null,
        // Abstand Zeiger→Gruppenmitte beim Greifen: daraus wird der Skalenfaktor.
        griffDist: null,
      };
      if (start.modus === 'scale' && u) {
        var r = stage.getBoundingClientRect();
        var mx = r.left + ((u.x0 + u.x1) / 2) / 100 * r.width;
        var my = r.top + ((u.y0 + u.y1) / 2) / 100 * r.height;
        start.griffDist = Math.hypot(e.clientX - mx, e.clientY - my) || 1;
        start.mitte = { x: mx, y: my };
      }
    }

    rahmen.addEventListener('pointerdown', function (e) {
      zeiger.set(e.pointerId, { x: e.clientX, y: e.clientY });
      try { rahmen.setPointerCapture(e.pointerId); } catch (e2) { /* egal */ }
      beginn(e);
      if (zeiger.size === 2) {
        var pts = Array.from(zeiger.values());
        start.dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        start.modus = 'pinch';
      }
      rahmen.classList.add('is-aktiv');
      e.preventDefault();
      e.stopPropagation();          // sonst zieht das Foto darunter mit
    });

    rahmen.addEventListener('pointermove', function (e) {
      if (!zeiger.has(e.pointerId) || !start) return;
      zeiger.set(e.pointerId, { x: e.clientX, y: e.clientY });
      var k = pctProPx();
      if (start.modus === 'pinch' && zeiger.size >= 2) {
        var pts = Array.from(zeiger.values());
        var d = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        if (start.dist) {
          engine.setGroupAdjust(gid, {
            xPercent: start.st.xPercent, yPercent: start.st.yPercent,
            scale: start.st.scale * (d / start.dist),
          });
        }
      } else if (start.modus === 'scale') {
        var d2 = Math.hypot(e.clientX - start.mitte.x, e.clientY - start.mitte.y);
        engine.setGroupAdjust(gid, {
          xPercent: start.st.xPercent, yPercent: start.st.yPercent,
          scale: start.st.scale * (d2 / start.griffDist),
        });
      } else {
        engine.setGroupAdjust(gid, {
          xPercent: start.st.xPercent + (e.clientX - start.sx) * k,
          yPercent: start.st.yPercent + (e.clientY - start.sy) * k,
          scale: start.st.scale,
        });
      }
      richteAus(engine, gid, ui);
      e.preventDefault();
      e.stopPropagation();
    });

    var ende = function (e) {
      zeiger.delete(e.pointerId);
      if (!zeiger.size) { start = null; rahmen.classList.remove('is-aktiv'); }
      else beginn(e);
    };
    rahmen.addEventListener('pointerup', ende);
    rahmen.addEventListener('pointercancel', ende);

    rahmen.addEventListener('keydown', function (e) {
      var st = engine.getGroupAdjust(gid);
      var n = { xPercent: st.xPercent, yPercent: st.yPercent, scale: st.scale };
      switch (e.key) {
        case 'ArrowLeft':  n.xPercent -= SCHRITT; break;
        case 'ArrowRight': n.xPercent += SCHRITT; break;
        case 'ArrowUp':    n.yPercent -= SCHRITT; break;
        case 'ArrowDown':  n.yPercent += SCHRITT; break;
        case '+': case 'Add':      n.scale += SCHRITT_SCALE; break;
        case '-': case 'Subtract': n.scale -= SCHRITT_SCALE; break;
        default: return;
      }
      engine.setGroupAdjust(gid, n);
      richteAus(engine, gid, ui);
      e.preventDefault();
    });

    // Nach jedem Preview-Render nachziehen (Größenwechsel ändert nichts an den
    // Prozenten, aber ein Re-Render der Bühne kann den Rahmen verwaisen lassen).
    engine.on && engine.on('previewUpdated', function () { richteAus(engine, gid, ui); });
    richteAus(engine, gid, ui);
    return ui;
  }

  var TTG_NAMENSFELD = {
    mount: function (engine) {
      if (!engine || !engine.config || engine._grpBound) return;
      var ids = gruppenIds(engine);
      if (!ids.length) return;
      engine._grpBound = true;
      engine._grpUi = {};
      for (var i = 0; i < ids.length; i++) {
        engine._grpUi[ids[i]] = bindGruppe(engine, ids[i]);
      }
    },
    /** Nachzügler-Sicherung: das Modul lädt NACH einer bereits gemounteten
     *  Engine. Der Regelweg ist umgekehrt — engine._mountGroupHandles() ruft
     *  mount(), sobald die Schritte stehen. */
    mountAll: function () {
      var nodes = document.querySelectorAll('ttg-customizer');
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].engine) TTG_NAMENSFELD.mount(nodes[i].engine);
      }
    },
  };

  window.TTG_NAMENSFELD = TTG_NAMENSFELD;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', TTG_NAMENSFELD.mountAll);
  } else {
    TTG_NAMENSFELD.mountAll();
  }
})();
